import {enableProdMode, provideZoneChangeDetection, importProvidersFrom} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {AppComponent} from './app/app.component';
import { initChunkErrorReloadGuard } from '@base/chunk-reload.guard';

if (environment.production) {
    enableProdMode();
}

initChunkErrorReloadGuard();

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(AppModule),
        provideZoneChangeDetection(),
    ]
})
    // eslint-disable-next-line @/no-console
    .catch(err => console.error(err));
